<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <el-button
          class="d-none d-lg-block"
          circle
          @click="minimizeSidebar"
          aria-controls="navigation-index"
          aria-expanded="false"
          aria-label="Toggle navigation"
          data-cy="navigation-button"
        >
          <font-awesome-icon
            :icon="$sidebar.isMinimized ? 'ellipsis-v' : 'bars'"
            fixed-width
          ></font-awesome-icon>
        </el-button>
      </div>
      <button
        type="button"
        class="navbar-toggler navbar-toggler-right"
        :class="{ toggled: $sidebar.showSidebar }"
        aria-expanded="false"
        @click="toggleSidebar"
      >
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="nav navbar-nav mr-auto"></ul>
        <ul class="navbar-nav" v-if="!menus.loading">
          <div v-if="menus.menus.profile">
            <template v-for="menu in menus.menus.profile.items">
              <template v-if="menu.mini === 'CE'">
                <a
                  @click="logout"
                  class="btn btn-danger btn-signout"
                  style="font-weight: bold"
                >
                  {{ menu.descripcion }}
                </a>
              </template>
            </template>
          </div>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapState } from "vuex";
import auth from "@/service/auth";

export default {
  computed: {
    ...mapState({
      menus: (state) => state.menus,
    }),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    routeTitle() {
      const { title } = this.$route.meta;
      if (!title || 0 === title.length) {
        return this.$route.name;
      }
      return title;
    },
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    logout() {
      auth.logout();
    },
  },
};
</script>
<style lang="scss">
.btn-color,
.navbar .navbar-brand {
  color: #606266 !important;
}
</style>
